<template>
<div class="MJob_Info" :class="{padBom0: !showBottomBtn}">
    <div class="job_top_box">
        <div class="info_div">
            <div class="jobname_text">{{JobDetailInfo.jobname}}</div>
            <div class="salary_text">{{JobDetailInfo.salarytext}}</div>
        </div>
        <div class="tags_box">
            <van-tag color="#5EBDFF" plain>{{JobDetailInfo.edutypename}}</van-tag>
            <van-tag v-if="JobDetailInfo.agemin === 0 && JobDetailInfo.agemax === 0" color="#5EBDFF" plain>年龄不限</van-tag>
            <van-tag v-else color="#5EBDFF" plain>{{JobDetailInfo.agemin}}岁-{{JobDetailInfo.agemax}}岁</van-tag>
            <van-tag color="#5EBDFF" plain>{{JobDetailInfo.exptypename}}</van-tag>
            <van-tag color="#5EBDFF" plain><label v-if="JobDetailInfo.sextype === 0">性别</label>{{JobDetailInfo.sextypename}}</van-tag>
        </div>
    </div>
    <div class="content_warp">
        <div style="margin-top: 0;" class="title_box">基本信息</div>
        <div class="base_info_box">
            <p>工作地点：{{JobDetailInfo.jobplace}}</p>
            <p v-if="JobDetailInfo.deptname !== ''">所属部门：{{JobDetailInfo.deptname}}</p>
            <p v-if="JobDetailInfo.hbname !== ''">汇报对象：{{JobDetailInfo.hbname}}</p>
        </div>
        <div class="title_box">岗位职责</div>
        <div class="job_info_box" v-html="JobDetailInfo.dutyinfo"></div>
        <div class="title_box">岗位要求</div>
        <div class="job_info_box" v-html="JobDetailInfo.resinfo"></div>
        <div v-if="JobDetailInfo.welfareinfo" class="title_box">福利待遇</div>
        <div v-if="JobDetailInfo.welfareinfo" class="base_info_box">
            <p>{{JobDetailInfo.welfareinfo}}</p>
        </div>
    </div>
    <div class="company_info_box">
        <div class="company_info_div">
            <img :src="require('@/common/images/mtalentimgs/icon_company.png')" alt="">
            <div>
                <p>{{JobDetailInfo.companydisplayname}}</p>
                <div>
                    <p>{{JobDetailInfo.industryname}}</p>
                    <label></label>
                    <p>{{JobDetailInfo.companytypename}}</p>
                </div>
            </div>
        </div>
        <p class="desc_text">{{JobDetailInfo.desp}}</p>
    </div>
    <div class="job_bottom_box" v-if="showBottomBtn">
        <div class="btn_div index_btn_div" @click="toIndex">
            <img :src="require('@/common/images/mtalentimgs/bottom_icon1.png')" alt="">
            <span>首页</span>
        </div>
        <div @click="serviceQrUrlPop = true" class="btn_div">
            <img :src="require('@/common/images/mtalentimgs/bottom_icon2.png')" alt="">
            <span>客服</span>
        </div>
        <van-button @click="sendResumeBtn" v-if="JobDetailInfo.status === 1" size="large" :color="JobDetailInfo.issendresum === 1 ? '#2E7FFF' : '#FFBF81'"><img :src="require('@/common/images/mtalentimgs/btn_icon.png')" alt="">{{JobDetailInfo.issendresum === 1 ? '投递简历' : '已投递'}}</van-button>
        <van-button v-else @click="StopHiringBtn" size="large" color="#999">停止招聘</van-button>
    </div>
    <div class="serviceqrurl_pop">
        <van-popup v-model="serviceQrUrlPop" position="center">
            <div class="serviceqrurl_box">
                <img class="service_img" src="https://img.capwhale.com/capwhale_service_hr.png" alt="">
                <p class="tip_text">扫码添加专属客服</p>
                <p class="hot_line_text">热线：<span>0755-86393108</span></p>
                <img @click="serviceQrUrlPop = false" class="close_img" :src="require('@/common/images/mtalentimgs/icon_close.png')" alt="">
            </div>
        </van-popup>
    </div>
</div>
</template>

<script>
import {Dialog, Toast} from 'vant'
import {getJobDetail} from 'api/talentApi'
import {sendResumeInfo} from 'api/talent'
import {mapGetters, mapActions} from 'vuex'
import { getAssignKeyLocationSearch } from 'common/js/tools.js'
export default {
    name: 'MJobInfo',
    data() {
        return {
            serviceQrUrlPop: false,
            JobDetailInfo: {},
            showBottomBtn: true
        }
    },
    created() {
        if(!this.domainInfo.isMobile){
            this.$router.push({
                name: 'JobInfo',
                query: {'jobid': this.$route.query.jobid}
            })
        }
    },
    mounted() {
        this.findJobDetail()
        if (getAssignKeyLocationSearch('appflag', ['appByDM'])) {
            this.showBottomBtn = false
        } else {
            this.showBottomBtn = true
        }
    },
    methods: {
        sendResumeBtn() {
            if (this.user.isLogin) {
                if (this.JobDetailInfo.issendresum === 1) {
                    if (this.JobDetailInfo.fullrate === 0) {
                        Dialog.confirm({
                            message: '您当前暂未完善在线简历，请先完善在线简历后在进行岗位投递',
                            cancelButtonText: '暂不完善',
                            cancelButtonColor: '#999',
                            confirmButtonText: '完善简历 '
                        }).then(() => {
                            this.$router.push({name: 'MResume'})
                        }).catch(() => {})
                    } else if (this.JobDetailInfo.fullrate < 100) {
                        Dialog.confirm({
                            message: '请先将简历基本信息、工作经历、项目经历、教育经历填写完整再进行岗位投递',
                            cancelButtonText: '暂不完善',
                            cancelButtonColor: '#999',
                            confirmButtonText: '完善简历 '
                        }).then(() => {
                            this.$router.push({name: 'MResume'})
                        }).catch(() => {})
                    } else {
                        this.setLoading(true)
                        var params = {
                            jobinnerid: this.$route.query.jobid
                        }
                        sendResumeInfo({
                            data: Object.assign({}, params),
                            success: data => {
                                this.setLoading(false)
                                console.log(data.data)
                                this.JobDetailInfo.issendresum = 0
                                this.dialogVisible3 = true
                                Toast('投递成功')
                            },
                            error: data => {
                                this.setLoading(false)
                                this.$toast.fail(data.msg)
                            }
                        })
                    }
                } else {
                    Dialog.alert({
                        message: '您已投递过该岗位',
                    }).then(() => {})
                }
            } else {
                this.$router.push({name: 'MLogin'})
            }
        },
        findJobDetail() {
            this.setLoading(true)
            var params = {
                jobinnerid: this.$route.query.jobid
            }
            getJobDetail({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.JobDetailInfo = data.data
                },
                error: data => {
                    this.setLoading(false)
                    this.$toast.fail(data.msg)
                }
            })
        },
        StopHiringBtn() {
            Dialog.alert({
                message: '当前岗位已停止招聘',
            }).then(() => {})
        },
        toIndex() {
            this.$router.push({name: 'MTalentIndex'})
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'user',
            'domainInfo'
        ])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss">
.van-dialog {
    border-radius: 0.12rem;
}
.MJob_Info {
    font-family:PingFangSC-Regular,PingFang SC;
    padding-bottom: 1.2rem;
    &.padBom0 {
        padding-bottom: 0;
    }
    &>div {
        background-color: #FFF;
        .title_box {
            margin-bottom: 0.3rem;
            margin-top: 0.4rem;
            display: block;
            text-align: left;
            overflow: hidden;
            color: #2B5278;
            line-height: 0.4rem;
            font-size: 0.28rem;
            padding-bottom: 0.1rem;
            position: relative;
            font-weight: bold;
        }
        .title_box::after {
            content: "";
            position: absolute;
            bottom: 0;
            left: 0;
            width: 0.64rem;
            height: 0.04rem;
            background: transparent url(../../../common/images/mtalentimgs/bg_line.png) left top no-repeat;
            background-size: 100%;
        }
    }
    .job_top_box {
        padding: 0.4rem 0.32rem;
        .info_div {
            display: flex;
            justify-content: space-between;
            margin-bottom: 0.28rem;
            .jobname_text {
                width: 4.72rem;
                font-weight: bold;
                line-height: 0.58rem;
                color: #333;
                font-size: 0.42rem;
            }
            .salary_text {
                font-weight: bold;
                line-height: 0.46rem;
                color: #FF7F04;
                font-size: 0.32rem;
                padding-top: 0.065rem;
            }
        }
        .tags_box {
            &>span {
                font-size: 0.24rem;
            }
            span + span {
                margin-left: 0.2rem;
            }
        }
    }
    .content_warp {
        color: #666;
        margin-top: 0.2rem;
        padding: 0.4rem 0.32rem;
        .base_info_box {
            &>p {
                line-height: 0.4rem;
                font-size: 0.28rem;
            }
            p + p {
                margin-top: 0.2rem;
            }
        }
        .job_info_box {
            text-align: justify;
            line-height: 0.46rem;
            font-size: 0.28rem;
        }
    }
    .company_info_box {
        padding: 0.32rem;
        margin-top: 0.2rem;
        .company_info_div {
            display: flex;
            padding-bottom: 0.32rem;
            margin-bottom: 0.32rem;
            border-bottom: 0.01rem solid #E5E5E5;
            &>img {
                width: 1.02rem;
                height: 1.02rem;
                margin-right: 0.2rem;
            }
            &>div {
                padding-top: 0.05rem;
                &>p {
                    line-height: 0.4rem;
                    color: #333;
                    margin-bottom: 0.12rem;
                    font-size: 0.28rem;
                }
                &>div {
                    display: flex;
                    align-items: center;
                    label {
                        background-color: #E5E5E5;
                        width: 0.02rem;
                        height: 0.28rem;
                        margin: 0 0.2rem;
                    }
                    p {
                        line-height: 0.4rem;
                        font-size: 0.28rem;
                        color: #666;
                    }
                }
            }
        }
        .desc_text {
            line-height: 0.46rem;
            font-size: 0.28rem;
            color: #666;
        }
    }
    .job_bottom_box {
        position: fixed;
        bottom: 0;
        height: 1rem;
        width: 100vw;
        display: flex;
        background-color: #FFF;
        .btn_div {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            width: 0.9rem;
            color: #2E7FFF;
            position: relative;
            img {
                width: 0.4rem;
                height: 0.4rem;
                margin-bottom: 0.02rem;
            }
            span {
                font-size: 0.22rem;
                line-height: 0.3rem;
            }
        }
        .btn_div:active {
            background-color: #f2f3f5;
        }
        .index_btn_div::after {
            content: '';
            width: 0.02rem;
            height: 0.5rem;
            background-color: #E5E5E5;
            position: absolute;
            right: -0.01rem;
            top: 0.24rem;
        }
        .van-button {
            width: 5.7rem;
            border-radius: 0;
            .van-button__text {
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 0.32rem;
                img {
                    width: 0.36rem;
                    height: 0.36rem;
                    margin-right: 0.1rem;
                }
            }
        }
    }
    .serviceqrurl_pop {
        .van-popup--center {
            background: transparent;
            height: 6.1rem;
            .serviceqrurl_box {
                background-color: #fff;
                position: relative;
                width: 4.6rem;
                padding-top: 0.2rem;
                padding-bottom: 0.66rem;
                box-sizing: border-box;
                border-radius:0.15rem;
                display: flex;
                flex-direction: column;
                align-items: center;
                color: #333;
                .service_img {
                    width: 3rem;
                    height: 3rem;
                }
                .tip_text {
                    margin: 0.2rem 0;
                }
                .hot_line_text, .tip_text {
                    line-height:0.4rem;
                    font-size:0.28rem;
                    span {
                        color: #2E7FFF;
                    }
                }
                .close_img {
                    width: 0.6rem;
                    height: 0.6rem;
                    position: absolute;
                    bottom: -1rem;
                    left: 2rem;
                }
            }
        }
    }
}
</style>